/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientInvestmentInfoViewModel } from './ClientInvestmentInfoViewModel';
import {
    ClientInvestmentInfoViewModelFromJSON,
    ClientInvestmentInfoViewModelFromJSONTyped,
    ClientInvestmentInfoViewModelToJSON,
} from './ClientInvestmentInfoViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfClientInvestmentInfoViewModel
 */
export interface ResultOfClientInvestmentInfoViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfClientInvestmentInfoViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientInvestmentInfoViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfClientInvestmentInfoViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientInvestmentInfoViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientInvestmentInfoViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfClientInvestmentInfoViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfClientInvestmentInfoViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ClientInvestmentInfoViewModel}
     * @memberof ResultOfClientInvestmentInfoViewModel
     */
    data?: ClientInvestmentInfoViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfClientInvestmentInfoViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfClientInvestmentInfoViewModel interface.
 */
export function instanceOfResultOfClientInvestmentInfoViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfClientInvestmentInfoViewModelFromJSON(json: any): ResultOfClientInvestmentInfoViewModel {
    return ResultOfClientInvestmentInfoViewModelFromJSONTyped(json, false);
}

export function ResultOfClientInvestmentInfoViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfClientInvestmentInfoViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ClientInvestmentInfoViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfClientInvestmentInfoViewModelToJSON(value?: ResultOfClientInvestmentInfoViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ClientInvestmentInfoViewModelToJSON(value.data),
        'Count': value.count,
    };
}

